import classNames from 'classnames'
import * as React from 'react'
import type {MouseEventHandler} from 'react'

import IconButton from '../../../../common/IconButton/IconButton'

import styles from './IndentedExpandHandle.css'

type IndentedContainerProps = {
  level: number
  extraIndent?: number
  className?: string
  children: React.ReactNode
}

const INDENT_LEVEL_UNIT = 16

export function IndentedContainer({
  level,
  extraIndent = 0,
  className,
  children,
}: IndentedContainerProps) {
  return (
    <div
      className={classNames(styles.container, className)}
      style={{paddingLeft: INDENT_LEVEL_UNIT * (level - 1) + extraIndent}}
    >
      {children}
    </div>
  )
}

type ExpandHandleProps = {
  expandable: boolean
  expanded?: boolean | null | undefined
  className?: string | undefined
  iconClassName?: string | undefined
  onClick?: MouseEventHandler
}

export function ExpandHandle({
  expandable,
  expanded,
  className,
  iconClassName,
  onClick,
}: ExpandHandleProps) {
  return expandable ? (
    <IconButton
      className={classNames(styles.icon, className)}
      iconClassName={iconClassName}
      title={expanded === true ? 'Collapse' : 'Expand'}
      icon={expanded === true ? 'chevron-down' : 'chevron-right'}
      onClick={onClick}
    />
  ) : null
}

export const EXPAND_HANDLE_WIDTH = 14
export default function IndentedExpandHandle({
  level,
  expandable,
  expanded,
  className,
  chevronClassName,
  chevronIconClassName,
}: Omit<IndentedContainerProps, 'children' | 'extraIndent'> &
  ExpandHandleProps & {
    chevronClassName?: string | undefined
    chevronIconClassName?: string | undefined
  }): React.ReactElement {
  return (
    <IndentedContainer
      className={classNames(styles.expandHandleContainer, className)}
      level={level}
      extraIndent={expandable ? 0 : EXPAND_HANDLE_WIDTH}
    >
      <ExpandHandle
        expanded={expanded}
        expandable={expandable}
        className={chevronClassName}
        iconClassName={chevronIconClassName}
      />
    </IndentedContainer>
  )
}
